import React from "react";
import PropTypes from "prop-types";

import { useCountries } from "hooks";
import Form from "components/Form";

export function BillingAddress({ disabled }) {
  const countries = useCountries();

  return (
    <React.Fragment>
      <Form.FieldGroup>
        <Form.Input
          name="firstName"
          label="First Name"
          placeholder="Cardholder First Name"
          required
          fluid
          disabled={disabled}
        />
        <Form.Input
          name="lastName"
          label="Last Name"
          placeholder="Cardholder Last Name"
          required
          fluid
          disabled={disabled}
        />
      </Form.FieldGroup>

      <Form.Input
        name="address"
        label="Address"
        placeholder="e.g. 11 Wall Street"
        required
        fluid
        disabled={disabled}
      />

      <Form.Input
        name="city"
        label="City"
        placeholder="e.g. New York"
        fluid
        required
        disabled={disabled}
      />

      <Form.FieldGroup>
        <Form.Dropdown
          name="country"
          label="Country"
          data-test="country-dropdown"
          placeholder="e.g. United States"
          required
          autoHighlight
          options={countries.all}
          getOptionSelected={(o, v) => {
            return o.code === v.code;
          }}
          getOptionLabel={({ label }) => {
            return label;
          }}
          renderOption={({ label }) => {
            return <React.Fragment>{label}</React.Fragment>;
          }}
        />

        <Form.Input
          name="zipCode"
          label="Postal/Zip Code"
          placeholder="e.g. 10005"
          required
          fluid
          disabled={disabled}
        />
      </Form.FieldGroup>
    </React.Fragment>
  );
}

BillingAddress.propTypes = { disabled: PropTypes.bool };
BillingAddress.defaultProps = { disabled: false };

export default BillingAddress;
